<template>
  <div class="container">
    <div class="alert alert-danger text-center font-weight-bold" v-if="notSupported">Your browser is not supported. Please use a different browser.</div>
    <div class="row justify-content-center my-3 my-lg-5">
      <div class="col-sm-12 col-md-10 col-xl-7 my-4">

        <div class="card shadow-sm px-3">
          <div class="mt-3">
            <slot name="logo"/>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
